module.exports = __webpack_public_path__ + "static/media/lite-graphic.ea70d933.png";